import { hydrateRoot } from 'react-dom/client';
import { RemixBrowser } from '@remix-run/react';
import { initAmplitude } from './lib/amplitude.client';
import { initSentry } from './lib/sentry.client';

initSentry();
initAmplitude();

// eslint-disable-next-line react/no-deprecated
hydrateRoot(document, <RemixBrowser />);
